import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { JoinNetworkForm } from './JoinNetworkForm';
export function MakeDifferenceCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [formOpen, setFormOpen] = useState(false);
  const {
    t,
    language
  } = useLanguage();
  return <section ref={ref} className="bg-white pt-8 pb-16 lg:pt-12 lg:pb-24" data-id="element-1896">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1897">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.2
      }} className="text-center bg-gradient-to-r from-haa-blue via-haa-navy to-haa-blue rounded-3xl p-10 text-white" data-id="element-1898">
          <h3 className="font-bebas text-4xl sm:text-5xl tracking-wider mb-3" data-id="element-1899">
            {t('leadership.cta.heading')}
          </h3>
          <p className="font-nunito text-white/80 text-lg mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-1900">
            {language === 'ES' ? '¿Eres estudiante universitario, dueño de negocio, profesional, líder comunitario, quieres aprender más, o simplemente buscas conectar? Únete a nuestra red y ayuda a construir una plataforma compartida que eleve las voces hondureño-americanas en ambos países.' : 'Are you a college student, business owner, professional, community leader, wanting to learn more, or just looking to connect? Join our network and help build a shared platform elevating Honduran-American voices across both countries.'}
          </p>
          <motion.button onClick={() => setFormOpen(true)} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.97
        }} className="inline-block bg-white text-haa-navy font-nunito font-bold text-base px-8 py-4 rounded-full hover:bg-haa-offwhite transition-colors shadow-xl" data-id="element-1901">
            {t('leadership.cta.button')}
          </motion.button>
        </motion.div>
      </div>

      <JoinNetworkForm isOpen={formOpen} onClose={() => setFormOpen(false)} data-id="element-1902" />
    </section>;
}